import { Component, ViewEncapsulation, input } from '@angular/core';

export interface DetectionSummaryItem {
  label: string;
  value: string;
  href?: string;
  highlight?: boolean;
}

@Component({
  selector: 'ds-detection-summary-block',
  templateUrl: './detection-summary-block.html',
  styleUrl: './detection-summary-block.scss',
  encapsulation: ViewEncapsulation.None,
})
export class DetectionSummaryBlockComponent {
  readonly items = input.required<DetectionSummaryItem[]>();
}
